import { Languages } from "../../types";
import { cashboxCategoriesDictionary } from "./CashboxCategories";
import { cashboxStatementsDictionary } from "./CashboxStatements";
import { contractPaymentsDictionary } from "./ContractPayments";
import { createCashboxCategoryDictionary } from "./CreateCashboxCategory";
import { createContractPaymentDictionary } from "./CreateContractPayment";
import { ContractPaymentPagesDescriptions } from "./types";

export const getContractPaymentDescriptions = (systemLang: Languages): ContractPaymentPagesDescriptions => ({
    CASHBOX_STATEMENTS: cashboxStatementsDictionary[systemLang],
    CREATE_PAYMENT: createContractPaymentDictionary[systemLang],
    CONTRACT_PAYMENTS: contractPaymentsDictionary[systemLang],
    CASHBOX_CATEGORIES: cashboxCategoriesDictionary[systemLang],
    CREATE_CASHBOX_CATEGORY: createCashboxCategoryDictionary[systemLang],
})